export const LANGUAGE_EN = 'en';
export const LANGUAGE_AR = 'ar';
export const LANGUAGE_NOT_AVAILABLE = 'N/A'; // Todo: Remove this if not used anymore
export const LANGUAGE_NOT_DEFINED = 'undefined';
export const NEXT_CONFIG_DEFAULT_LOCALE = 'default';

export const SUPPORTED_LANGUAGES = [LANGUAGE_EN, LANGUAGE_AR];
